// extracted by mini-css-extract-plugin
export default {"label_spec":"AsyncTagSelect_label_spec__V13h4","inlinePlaceholder":"AsyncTagSelect_inlinePlaceholder__T+NUE"};